import React from 'react';
import BasicLayout from "../layout/BasicLayout";

export const Page404 = () => (
    <BasicLayout>
        <h2>Page not found.</h2>
    </BasicLayout>
);